module.exports = __webpack_public_path__ + "img/ZJ5278.e8117f8c.png";